<template>
  <w-sliding-popup type="setting" ref="slidingPopup" title="태스크 변수 설정" width="1200px" @close="close()">
    <el-row slot="content" type="flex" >
        <el-col :span="12" class="mr-r20">
          <el-row class="title-bar" type="flex" justify="space-between">
            <div class="vertical-center-box title-h3">변수 목록</div>
            <div class="vertical-center-box" align="right">
              <el-button class="mr-r4" @click="addVariable">변수 추가</el-button>
              <w-header-search-button size="mini" @click="showVariableSearchTool = !showVariableSearchTool"></w-header-search-button>
            </div>
          </el-row>
          <el-table-wrapper ref="variableTable" :column-default="columnDefault" :data="variableList" :columns="tableColumns"
          :show-search-tool="showVariableSearchTool" :show-custom-header="true" remote pagination :total="variableTotal"
          @select="onSelect" @select-all="onSelectAll" @condition-change="loadData" @pagination-change="handlerPaginationChange" @total-change="handlerPaginationChange">
          </el-table-wrapper>
        </el-col>
        <el-col :span="12">
          <el-row class="title-bar" type="flex" justify="space-between">
            <div class="vertical-center-box title-h3">태스크 변수 목록</div>
            <div class="vertical-center-box" align="right">
              <el-button class="mr-r4" @click="onReleaseButtonClick">해제</el-button>
              <w-header-search-button size="mini" @click="showTaskVarSearchTool = !showTaskVarSearchTool"></w-header-search-button>
            </div>
          </el-row>
          <el-table-wrapper ref="taskVarTable" :column-default="columnDefault" :data="taskVarList" :columns="tableColumns"
          :show-search-tool="showTaskVarSearchTool" :show-custom-header="true" pagination :total="taskVarTotal"
          @selection-change="changeCheckedRow" @pagination-change="handlerPaginationChange" @total-change="handlerPaginationChange">
          </el-table-wrapper>
        </el-col>
        <w-variable-setting-popup @re-load="loadData" ref="variableSettingPopup"></w-variable-setting-popup>
    </el-row>
    <div slot="footer">
      <el-button size="large" type="solid" @click="onSaveButtonClick">저장</el-button>
      <el-button size="large" @click="close">취소</el-button>
    </div>
  </w-sliding-popup>
</template>

<script>
import { isNil, difference, cloneDeep, map } from 'lodash';
import { getValueAfterCheckEmpty } from '@/utils/string';
import msgUtil from '@/utils/message';
import { columnDefault, defaultPagination } from '@/constants/table';
import amsSettingsApi from '@/api/settings/server/ams-settings';
import WVariableSettingPopup from '../../VariableSetting/popup/VariableSettingPopup';

const defaultFormatter = (row, column, value) => getValueAfterCheckEmpty(value);
const pagination = cloneDeep(defaultPagination);

export default {
  name: 'WTaskVarSettingPopup',
  components: {
    WVariableSettingPopup,
  },
  props: {
    selectedTask: Object,
    originTaskVarList: Array,
  },
  data() {
    const tableColumns = [
      { type: 'selection' },
      { prop: 'variableId', label: '변수 아이디', searchable: true, sortable: true, remoteProp: 'variable_id' },
      { prop: 'variableName', label: '변수명', searchable: true, sortable: true, remoteProp: 'variable_name' },
      { prop: 'variableDefaultValue', label: '변수값', formatter: defaultFormatter },
    ];
    return {
      showVariableSearchTool: false,
      showTaskVarSearchTool: false,
      columnDefault,
      tableColumns,
      variableTotal: 0,
      taskVarTotal: 0,
      pagination,
      variableList: [],
      taskVarList: [],
      originTaskVarIds: [],
      checkedRows: [],
    };
  },
  methods: {
    open() {
      this.$refs.slidingPopup.visible = true;
      this.loadData();
    },
    close() {
      this.$refs.slidingPopup.visible = false;
      this.$refs.variableTable.clearFilter();
      this.$refs.taskVarTable.clearFilter();
      this.$refs.variableTable.getTable().clearSelection();
      this.$refs.taskVarTable.getTable().clearSelection();
      this.showVariableSearchTool = false;
      this.showTaskVarSearchTool = false;
    },
    addVariable() {
      this.$refs.variableSettingPopup.open();
    },
    loadData() {
      const me = this;
      me.$nextTick(() => {
        const variableTable = me.$refs.variableTable;
        const tableParams = variableTable.getParameter();
        amsSettingsApi.getVariableList(tableParams).then((response) => {
          if (response.data.success) {
            me.variableList = response.data.data;
            me.variableTotal = response.data.total;
            me.taskVarList = cloneDeep(me.originTaskVarList);
            me.originTaskVarIds = map(me.originTaskVarList, (variable) => variable.variableId);
          }
        }).finally(() => {
          me.variableList.forEach((variable) => {
            const existVariable = me.taskVarList.find((e) => (e.variableId === variable.variableId));
            variableTable.getTable().toggleRowSelection(variable, !isNil(existVariable));
          });
        });
      });
    },
    onSelect(selection) {
      this.taskVarList = selection;
    },
    onSelectAll(selection) {
      this.taskVarList = selection;
    },
    changeCheckedRow(selection) {
      this.checkedRows = selection;
    },
    /**
     * 해제 버튼 click
     * @author jeee12
     * @return {[type]} [description]
     */
    onReleaseButtonClick() {
      this.checkedRows.forEach((row) => {
        this.taskVarList.splice(this.taskVarList.indexOf(row), 1);
      });
      this.toggleVariableRowSelection();
    },
    toggleVariableRowSelection() {
      this.variableList.forEach((variable) => {
        const existVar = this.taskVarList.find((e) => (e.variableId === variable.variableId));
        this.$refs.variableTable.getTable().toggleRowSelection(variable, !isNil(existVar));
      });
    },
    handlerPaginationChange(_pagination) {
      this.pagination = _pagination;
    },
    onSaveButtonClick() {
      const taskVarIds = this.taskVarList.map((data) => data.variableId).sort();
      const taskId = this.selectedTask.taskId;
      const insertTaskVarParams = difference(taskVarIds, this.originTaskVarIds).map((variableId) => ({ type: 'INSERT', taskId, variableId }));
      const deleteTaskVarParams = difference(this.originTaskVarIds, taskVarIds).map((variableId) => ({ type: 'DELETE', taskId, variableId }));
      if (insertTaskVarParams.length === 0 && deleteTaskVarParams.length === 0) {
        this.close();
        return;
      }

      const target = '태스크 변수';
      const action = msgUtil.action.SAVE;
      amsSettingsApi.updateTaskVariableList([...insertTaskVarParams, ...deleteTaskVarParams]).then((response) => {
        if (response.data.success) {
          this.$emit('re-load', taskId);
          this.close();
        }
        this.$message(msgUtil.getResultMsgData(action, target, response.data.success));
      }).catch(() => {
        this.$message(msgUtil.getResultMsgData(action, target, false));
      });
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/settings/server/AmsSettings/TaskSetting/popup/TaskVarSettingPopup.vue